module.exports = __webpack_public_path__ + "img/Mstorybg702.c8553e58.png";